import { errorAlert } from '../components/ToastMessage';

interface Props {
  formik: any;
  data: { [key: string]: string }
}
// export const formikErrorHandler = ({ formik, data }: Props): void => {
//   const errors = {};
//   Object.keys(data || {})?.forEach(key => {
//     let newKey = undefined;
//     if (key.includes('.')) {
//       const arr = key.split('.');
//       newKey = arr[1];
//     } else {
//       newKey = key;
//     }
//     errors[newKey] = data?.[key]?.[0];
//   });
//   console.log('errors', errors);
//   formik.setErrors(errors);
//   const err = Object.keys(errors);
//   if (err.length) {
//     const input = document.querySelector(
//         `input[id=${err[0]}]`
//     );
//
//     input?.scrollIntoView({
//       behavior: 'smooth',
//       block: 'center',
//       inline: 'start',
//     });
//   }
// };

export const formikErrorHandler = ({ formik, data }: Props): void => {
  const errors = {};
  const touched = {};
  Object.keys(data || {})?.forEach(key => {
    let newKey = undefined;
    if (key.includes('.')) {
      const arr = key.split('.').join('');
      newKey = arr;
    } else {
      newKey = key;
    }
    errors[newKey] = data?.[key]?.[0];
    touched[newKey] = true;
  });

  formik.setFormikState(prevState => ({
    ...prevState,
    errors: { ...errors },
    touched: { ...touched },
  }));

  scrollToError(errors, 'formikErrorHandler');
};

export const scrollToError = (errors, component?: string): void => {
  try {
    const err = Object.keys(errors || {});
    if (err?.length) {
      const id = err?.[0];

      if (id) {
        const input = document.querySelector(`[id=${id}]`);
        if (input) {
          input?.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'start',
          });
        }
      }
    }
  } catch (e) {
    console.error('scrollToError error', e);
  }
};
